import { defineComponent as g, ref as n, computed as r, createElementBlock as S, openBlock as d, createElementVNode as i, createBlock as T, renderSlot as l, Teleport as E, normalizeStyle as f, unref as $, createTextVNode as k, toDisplayString as B } from "vue";
import { u as D, a as O, f as A, o as F, b as I } from "./floating-ui.vue-pzUuloyX.js";
import { a as P } from "./index-ConQ3o31.js";
const z = {
  ref: "wrapper",
  class: "stash-tooltip__wrapper tw-relative tw-inline-flex tw-h-fit tw-w-fit"
}, M = 6, N = 12, X = /* @__PURE__ */ g({
  __name: "Tooltip",
  props: {
    disableTeleport: { type: Boolean, default: !1 },
    side: { default: "top" },
    isDisabled: { type: Boolean, default: !1 },
    isOpen: { type: Boolean, default: !1 },
    teleportTo: { default: "#stash-menus-mount-node" },
    text: { default: "" }
  },
  setup(u) {
    const m = {
      top: "bottom",
      right: "left",
      bottom: "top",
      left: "right"
    }, t = u, a = n(null), p = n(null), c = n(null), { isOutside: h } = P(a), y = r(() => !t.isDisabled && (!h.value || t.isOpen)), _ = r(() => t.side), { floatingStyles: x, middlewareData: o, placement: b } = D(a, c, {
      whileElementsMounted: O,
      placement: _,
      middleware: [A(), F(N), I({ element: p })]
    }), v = r(() => {
      var s, w;
      const e = m[b.value];
      return {
        left: ((s = o.value.arrow) == null ? void 0 : s.x) != null ? `${o.value.arrow.x}px` : "",
        top: ((w = o.value.arrow) == null ? void 0 : w.y) != null ? `${o.value.arrow.y}px` : "",
        [e]: `-${M}px`
      };
    });
    return (e, s) => (d(), S("div", z, [
      i("span", {
        ref_key: "anchor",
        ref: a,
        "data-test": "stash-tooltip|anchor",
        class: "stash-tooltip__anchor"
      }, [
        l(e.$slots, "default")
      ], 512),
      (d(), T(E, {
        to: t.teleportTo,
        disabled: t.disableTeleport
      }, [
        i("div", {
          ref_key: "tooltip",
          ref: c,
          "data-test": "stash-tooltip",
          class: "stash-tooltip tw-pointer-events-none tw-z-screen tw-flex tw-w-[148px] tw-flex-col tw-items-center tw-whitespace-normal tw-rounded tw-bg-ice-900 tw-p-3 tw-text-center tw-text-xs tw-text-white tw-opacity-0 tw-shadow tw-transition-opacity",
          role: "tooltip",
          style: f({
            ...$(x),
            opacity: y.value ? 0.95 : 0
          })
        }, [
          l(e.$slots, "icon"),
          l(e.$slots, "content", {}, () => [
            k(B(t.text), 1)
          ]),
          l(e.$slots, "secondaryIcon"),
          i("div", {
            ref_key: "floatingArrow",
            ref: p,
            class: "stash-tooltip__arrow tw-absolute tw-z-behind tw-h-[12px] tw-w-[12px] tw-rotate-45 tw-bg-ice-900",
            style: f(v.value)
          }, null, 4)
        ], 4)
      ], 8, ["to", "disabled"]))
    ], 512));
  }
});
export {
  X as default
};
//# sourceMappingURL=Tooltip.js.map
